import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=07e8fce3&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=07e8fce3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e8fce3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www-user/apps/siacap-vilcabamba2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07e8fce3')) {
      api.createRecord('07e8fce3', component.options)
    } else {
      api.reload('07e8fce3', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=07e8fce3&scoped=true", function () {
      api.rerender('07e8fce3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/otros/Table/Main.vue"
export default component.exports